import React, { Component } from 'react';

import '../statics/css/bottommenu.css';

import Logo from '../statics/images/logo_default_white.png'
import iconTreino from '../statics/images/dumbell.svg'
import { Image } from 'react-bootstrap';
import { Glyphicon } from 'react-bootstrap';

import If from "../utils/If"

import IconMenuSvg from '../utils/icons-menus-svg'
import alunosSvg from '../statics/bottombar/alunos.svg'
import feedSvg from '../statics/bottombar/feed.svg'
import treinoSvg from '../statics/bottombar/treino.svg'
import sairSvg from '../statics/bottombar/sair.svg'
import backSvg from '../statics/bottombar/back.svg'

class BottomMenu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      activeMenu: 'home',
      sub_activeMenu: '',
    };

    this.actionMenu = this.actionMenu.bind(this);

  }

  componentWillMount() {
    //this.props.history.push('/login');
  }

  handleSubmit(user) {

    //console.log(user);
  }

  actionMenu(event, subMenus) {

    console.log("Event: " + event);
    this.state.activeMenu = event;
    this.setState({
      actionMenu: event,
    })
    if (!subMenus) {
      this.props.onHandleMenu(event);
    }

  }

  handleActionMenu(event) {
    this.setState({
      sub_activeMenu: event,
    })
    this.props.onHandleMenu(event);
  }

  render() {

    return (
      <nav id="bottombar">
        {/* <div className="bottombar-header">
          <Image src={Logo} responsive />
        </div> */}

        <div className="flex-bottom">


          <If test={this.state.activeMenu === 'treino'}>

            <div className={`menu-in flex-1`} onClick={() => this.actionMenu("home", true)}>
              <Image src={backSvg} responsive />
            </div>

            <div className={`menu-in flex-2`} onClick={() => this.handleActionMenu("treino/exercisesList")}>

              <h4>Lista de exercícios</h4>

            </div>

            <div className={`menu-in flex-2`} onClick={() => this.handleActionMenu("treino/trainingsList")}>

              <h4>Lista de treinos</h4>

            </div>

          </If>

          <If test={this.state.activeMenu === 'home'}>

            <If test={JSON.parse(localStorage.getItem("USER")) && JSON.parse(localStorage.getItem("USER")).role == "professor"}>

              <div className={`menu-in`} onClick={() => this.handleActionMenu("feed/publications")}>
                <Image src={feedSvg} responsive />
                <div className="main-menu">
                  <h4>Feed</h4>
                </div>

              </div>

              <div className={`menu-in`} onClick={() => this.handleActionMenu("alunos")}>
                <Image src={alunosSvg} responsive />
                <div className="main-menu">
                  <h4>Alunos</h4>
                </div>


              </div>

              <div className={`menu-in`} onClick={() => this.actionMenu("treino", true)}>
                <Image src={treinoSvg} responsive />
                <div className="main-menu">
                  <h4>Treino</h4>
                </div>


              </div>

            </If>

            <div className={`menu-in`} onClick={() => this.actionMenu("logout", false)}>
              <Image src={sairSvg} responsive />
              <div className="main-menu">
                <h4>Sair</h4>
              </div>

            </div>
          </If>
        </div >


      </nav >
    );
  }
}

export default BottomMenu;



// WEBPACK FOOTER //
// src/components/bottom-menu.js